// src/features/fourlink-config/components/blocks/Block1Steps/TareasRegistrosStep.jsx

import React, { useMemo, useState } from 'react';
import { CommentButton } from '../../shared/CommentButton';
import { TurnoFilter } from '../../shared/TurnoFilter';
import { PERIODICIDAD_OPTIONS, TIPO_DATOS_OPTIONS, WEEKDAY_OPTIONS } from '../../../utils/helpers/constants';

export const TareasRegistrosStep = ({
  tareasPorCategoriaDisponibles,
  hiddenCategoriasTareas,
  hiddenTareasPorCategoria,
  selectedTareas,
  collapsedCategories,
  tareasConfiguracion,
  selectedPlanes,
  selectedActivos,
  activosConfig,
  registrosActivosConfig,
  tareaFotos,
  horariosDisponibles,
  tareasErrors = [],
  onToggleTarea,
  onToggleCollapse,
  onAddCategoriaTarea,
  onAddTareaEnCategoria,
  onHideCategorias,
  onRestoreCategoria,
  onHideTareas,
  onRestoreTarea,
  onTareaConfigChange,
  onUpdateRegistrosConfig,
  onFotoChange,
  onFotoRemove,
  onAddHorario,
  onCommentClick,
  onChecklistClick,
  hasSectionComment = false,
  hasCommentForTarget,
  comments = {},
  getCategoriaComment,
  turnoFilterOptions,
  turnoFilterFilteredOptions,
  turnoFilterSelected,
  turnoFilterOpen,
  turnoFilterSearch,
  onTurnoFilterToggle,
  onTurnoFilterSearchChange,
  onTurnoFilterSelectionToggle,
  onTurnoFilterClear,
  turnoFilterRef,
  turnoFilterButtonText,
  isTurnoFilterActive,
  tareaCumpleFiltroDeTurnos,
}) => {
  const tareasEntries = useMemo(() => Object.entries(tareasPorCategoriaDisponibles || {}), [
    tareasPorCategoriaDisponibles,
  ]);

  const [isAddCategoriaModalOpen, setIsAddCategoriaModalOpen] = useState(false);
  const [isHideCategoriasModalOpen, setIsHideCategoriasModalOpen] = useState(false);
  const [newCategoriaName, setNewCategoriaName] = useState('');
  const [categoriasToHide, setCategoriasToHide] = useState([]);

  const [categoriaModalData, setCategoriaModalData] = useState(null); // {categoria, mode:'add'|'hide'}
  const [newTareaName, setNewTareaName] = useState('');
  const [tareasToHide, setTareasToHide] = useState([]);

  const hiddenCategoriasList = useMemo(
    () => (Array.isArray(hiddenCategoriasTareas) ? hiddenCategoriasTareas : []),
    [hiddenCategoriasTareas],
  );

  const filteredTurnoOptions = useMemo(() => {
    if (Array.isArray(turnoFilterFilteredOptions)) return turnoFilterFilteredOptions;
    const query = (turnoFilterSearch || '').trim().toLowerCase();
    if (!query) return turnoFilterOptions;
    return (turnoFilterOptions || []).filter((option) => {
      const text = `${option.label || ''} ${option.rangeText || ''}`.toLowerCase();
      return text.includes(query);
    });
  }, [turnoFilterFilteredOptions, turnoFilterOptions, turnoFilterSearch]);

  const turnoFilterActive = typeof isTurnoFilterActive === 'boolean'
    ? isTurnoFilterActive
    : (Array.isArray(turnoFilterSelected) && turnoFilterSelected.length > 0);

  const turnoFilterButtonLabel = useMemo(() => {
    if (typeof turnoFilterButtonText === 'string' && turnoFilterButtonText.trim()) {
      return turnoFilterButtonText;
    }
    if (!Array.isArray(turnoFilterSelected) || turnoFilterSelected.length === 0) {
      return 'Filtrar por turno';
    }
    const labelMap = new Map((turnoFilterOptions || []).map((opt) => [opt.id, opt.label]));
    const labels = turnoFilterSelected.map((id) => labelMap.get(id)).filter(Boolean);
    if (labels.length <= 2) return labels.join(', ');
    const [first, second] = labels;
    return `${first}, ${second} +${labels.length - 2}`;
  }, [turnoFilterButtonText, turnoFilterSelected, turnoFilterOptions]);

  const safeHasComment = typeof hasCommentForTarget === 'function' ? hasCommentForTarget : () => false;
  const safeHasTaskComment = (tareaId) => Boolean(comments?.[`tarea:${tareaId}`]);

  const toggleCategoriaToHide = (categoria) => {
    setCategoriasToHide((prev) =>
      prev.includes(categoria) ? prev.filter((c) => c !== categoria) : [...prev, categoria],
    );
  };

  const handleConfirmHideCategorias = () => {
    if (typeof onHideCategorias === 'function' && categoriasToHide.length > 0) {
      onHideCategorias(categoriasToHide, tareasPorCategoriaDisponibles);
    }
    setCategoriasToHide([]);
    setIsHideCategoriasModalOpen(false);
  };

  const handleCreateCategoria = (e) => {
    e.preventDefault();
    if (!newCategoriaName.trim()) return;
    const created = typeof onAddCategoriaTarea === 'function' ? onAddCategoriaTarea(newCategoriaName.trim()) : false;
    if (created === false) return;
    setNewCategoriaName('');
    setIsAddCategoriaModalOpen(false);
  };

  const openTareasModal = (categoria, mode) => {
    setCategoriaModalData({ categoria, mode });
    setNewTareaName('');
    setTareasToHide([]);
  };

  const handleCreateTarea = (e) => {
    e.preventDefault();
    if (!categoriaModalData?.categoria || !newTareaName.trim()) return;
    const created = typeof onAddTareaEnCategoria === 'function'
      ? onAddTareaEnCategoria(categoriaModalData.categoria, newTareaName.trim())
      : false;
    if (created === false) return;
    setNewTareaName('');
    setCategoriaModalData(null);
  };

  const handleHideTareas = () => {
    if (!categoriaModalData?.categoria || tareasToHide.length === 0) return;
    if (typeof onHideTareas === 'function') {
      onHideTareas(categoriaModalData.categoria, tareasToHide);
    }
    setTareasToHide([]);
    setCategoriaModalData(null);
  };

  const toggleTareaToHide = (tareaName) => {
    setTareasToHide((prev) =>
      prev.includes(tareaName) ? prev.filter((t) => t !== tareaName) : [...prev, tareaName],
    );
  };

  const renderModalShell = (children) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 px-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg p-6 relative">
        {children}
      </div>
    </div>
  );

  const toggleDiaSemana = (tareaId, currentValue, dia) => {
    const set = new Set(
      (currentValue || '')
        .split(',')
        .map((d) => d.trim().toLowerCase())
        .filter(Boolean),
    );
    if (set.has(dia)) {
      set.delete(dia);
    } else {
      set.add(dia);
    }
    onTareaConfigChange(tareaId, 'dias_semana', Array.from(set).join(','));
  };

  const renderTareaRow = (tarea) => {
    const tareaId = tarea.id || tarea.name || tarea.nombre;
    const isSelected = selectedTareas.includes(tareaId);
    const config = tareasConfiguracion?.[tareaId] || {};
    const foto = tareaFotos?.[tareaId];
    const diasSemana = config.dias_semana || tarea.dias_semana || '';
    const diasSemanaSet = new Set(
      diasSemana
        .split(',')
        .map((d) => d.trim().toLowerCase())
        .filter(Boolean),
    );
    const periodicidadSeleccionada = (config.periodicidad || tarea.periodicidad || 'ninguna').toLowerCase();
    const tipoSeleccionado = (config.tipo_datos || tarea.type || 'ninguno').toLowerCase();
    const turnosHabilitados = Boolean(config.turnos?.habilitado);
    const turnosSeleccionados = Array.isArray(config.turnos?.seleccionados) ? config.turnos.seleccionados : [];
    const baseChecklists = Array.isArray(tarea.checklists) ? tarea.checklists : [];
    const computedChecklists =
      baseChecklists.length > 0
        ? baseChecklists
        : tipoSeleccionado === 'checklist'
          ? [
              {
                id: tarea.id || `checklist-${tarea.name || 'tarea'}`,
                nombre: tarea.name ? `Checklist de ${tarea.name}` : 'Checklist',
              },
            ]
          : [];

    return (
      <div
        key={tareaId}
        className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm hover:border-blue-200 transition-colors"
      >
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-start gap-3">
            <input
              type="checkbox"
              className="mt-1 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              checked={isSelected}
              onChange={() => onToggleTarea(tareaId)}
            />
            <div>
              <div className="flex items-center gap-2">
                <p className="text-lg font-semibold text-gray-900">{tarea.name || 'Tarea sin nombre'}</p>
                {computedChecklists.length > 0 && (
                  <span className="rounded-full bg-blue-50 px-2 py-1 text-xs font-semibold text-blue-700">
                    Checklist
                  </span>
                )}
              </div>
              <p className="text-sm text-gray-600">
                {tarea.type && tarea.type !== 'ninguno' ? tarea.type : 'Sin tipo definido'}
              </p>
            </div>
          </div>
          <CommentButton
            onClick={() => onCommentClick({ key: `tarea:${tareaId}`, label: tarea.name })}
            hasComment={safeHasTaskComment(tareaId)}
            srLabel={`Anadir comentario para ${tarea.name}`}
          />
        </div>

        {isSelected && (
          <div className="mt-4 grid gap-4 border-t border-gray-100 pt-4 lg:grid-cols-2">
            <div className="space-y-4">
              <div className="flex items-center justify-between rounded-lg bg-gray-50 px-4 py-3">
                <div>
                  <p className="text-sm font-semibold text-gray-800">Requiere foto</p>
                  <p className="text-xs text-gray-500">Indica si se debe capturar evidencia fotografica.</p>
                </div>
                <button
                  type="button"
                  onClick={() => onTareaConfigChange(tareaId, 'requiere_foto', !config.requiere_foto)}
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${
                    config.requiere_foto ? 'bg-blue-600' : 'bg-gray-300'
                  }`}
                >
                  <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${
                      config.requiere_foto ? 'translate-x-6' : 'translate-x-1'
                    }`}
                  />
                </button>
              </div>

              <div className="rounded-lg border border-dashed border-blue-300 bg-blue-50/40 p-4">
                <p className="text-sm font-semibold text-gray-800">Evidencia fotografica</p>
                <p className="text-xs text-gray-500 mb-3">Haz clic o arrastra un archivo.</p>
                <label className="flex h-32 cursor-pointer items-center justify-center rounded-lg border border-dashed border-blue-300 bg-white text-sm font-semibold text-blue-700 hover:bg-blue-50">
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={(e) => e.target.files?.[0] && onFotoChange(tareaId, e.target.files[0])}
                  />
                  {foto ? foto.name || 'Imagen adjunta' : 'Anadir imagen'}
                </label>
                {foto && (
                  <button
                    type="button"
                    onClick={() => onFotoRemove(tareaId)}
                    className="mt-2 text-xs font-semibold text-red-600 hover:text-red-800"
                  >
                    Quitar imagen
                  </button>
                )}
              </div>

              <div className="space-y-2">
                <p className="text-sm font-semibold text-gray-800">Tipo de datos</p>
                <div className="flex flex-wrap gap-2">
                  {TIPO_DATOS_OPTIONS.map((option) => {
                    const isActive = tipoSeleccionado === option.value;
                    return (
                      <button
                        key={option.value}
                        type="button"
                        onClick={() => onTareaConfigChange(tareaId, 'tipo_datos', option.value)}
                        className={`rounded-full border px-4 py-2 text-sm font-semibold transition ${
                          isActive
                            ? 'border-blue-600 bg-blue-600 text-white shadow-sm'
                            : 'border-gray-300 bg-white text-gray-700 hover:border-blue-400'
                        }`}
                      >
                        {option.label}
                      </button>
                    );
                  })}
                </div>
                {computedChecklists.length > 0 && (
                  <div className="text-sm text-gray-700">
                    <div className="mt-2">
                      <button
                        type="button"
                        onClick={() => onChecklistClick({ ...tarea, checklists: computedChecklists })}
                        className="rounded-lg border border-blue-200 px-3 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-50"
                      >
                        Ver checklist
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="space-y-4">
              <div className="space-y-2">
                <p className="text-sm font-semibold text-gray-800">Periodicidad</p>
                <div className="flex flex-wrap gap-2">
                  {PERIODICIDAD_OPTIONS.map((option) => {
                    const isActive = periodicidadSeleccionada === option.value;
                    return (
                      <button
                        key={option.value}
                        type="button"
                        onClick={() => onTareaConfigChange(tareaId, 'periodicidad', option.value)}
                        className={`rounded-full border px-4 py-2 text-sm font-semibold transition ${
                          isActive
                            ? 'border-blue-600 bg-blue-600 text-white shadow-sm'
                            : 'border-gray-300 bg-white text-gray-700 hover:border-blue-400'
                        }`}
                      >
                        {option.label}
                      </button>
                    );
                  })}
                </div>
              </div>

              <div className="space-y-2">
                <p className="text-sm font-semibold text-gray-800">Dias de semana</p>
                <div className="flex flex-wrap gap-2">
                  {WEEKDAY_OPTIONS.map((option) => {
                    const isActive = diasSemanaSet.has(option.value);
                    const disabled =
                      periodicidadSeleccionada === 'esporadica' || periodicidadSeleccionada === 'ninguna';
                    return (
                      <button
                        key={option.value}
                        type="button"
                        disabled={disabled}
                        onClick={() => toggleDiaSemana(tareaId, diasSemana, option.value)}
                        className={`rounded-full px-4 py-2 text-sm font-semibold transition ${
                          isActive
                            ? 'bg-blue-600 text-white shadow-sm'
                            : 'bg-white text-gray-700 border border-gray-300 hover:border-blue-400'
                        } ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`}
                      >
                        {option.label}
                      </button>
                    );
                  })}
                </div>
                {periodicidadSeleccionada === 'diaria' && (
                  <p className="text-xs text-blue-600">Selecciona los dias que aplican para la ejecucion diaria.</p>
                )}
              </div>

              <div className="space-y-3 rounded-lg border border-gray-200 bg-gray-50 p-4">
                <label className="flex items-center gap-2 text-sm font-semibold text-gray-800">
                  <input
                    type="checkbox"
                    className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    checked={turnosHabilitados}
                    onChange={() =>
                      onTareaConfigChange(tareaId, 'turnos', {
                        habilitado: !turnosHabilitados,
                        seleccionados: turnosSeleccionados,
                      })
                    }
                  />
                  <span>Asignar por turnos</span>
                </label>

                {turnosHabilitados && (
                  <div className="space-y-3">
                    {Array.isArray(horariosDisponibles) && horariosDisponibles.length > 0 ? (
                      <div className="space-y-2">
                        {horariosDisponibles.map((horario) => {
                          const horarioId = horario?.id || horario?.ID || horario?.uuid || horario?.guid;
                          const isChecked = horarioId ? turnosSeleccionados.includes(horarioId) : false;
                          return (
                            <label
                              key={horarioId || `${horario?.name || 'turno'}-${horario?.startTime || ''}-${horario?.endTime || ''}`}
                              className="flex items-start gap-3 rounded-lg border border-gray-200 bg-white px-3 py-2 shadow-sm hover:border-blue-300"
                            >
                              <input
                                type="checkbox"
                                className="mt-1 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                checked={isChecked}
                                onChange={() => {
                                  if (!horarioId) return;
                                  const set = new Set(turnosSeleccionados);
                                  if (set.has(horarioId)) {
                                    set.delete(horarioId);
                                  } else {
                                    set.add(horarioId);
                                  }
                                  onTareaConfigChange(tareaId, 'turnos', {
                                    habilitado: true,
                                    seleccionados: Array.from(set),
                                  });
                                }}
                              />
                              <div>
                                <p className="text-sm font-semibold text-gray-800">
                                  {horario?.name?.trim() || 'Turno sin nombre'}
                                </p>
                                <p className="text-xs text-gray-500">
                                  {horario?.startTime || ''} {horario?.endTime ? `- ${horario.endTime}` : ''}
                                </p>
                              </div>
                            </label>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="rounded-lg border border-yellow-200 bg-yellow-50 p-3 text-xs text-yellow-800">
                        No hay turnos configurados. Anade uno nuevo para esta tarea.
                      </div>
                    )}

                    <button
                      type="button"
                      onClick={() => onAddHorario(`Turno ${horariosDisponibles.length + 1}`)}
                      className="inline-flex items-center gap-2 rounded-lg border border-dashed border-blue-300 px-3 py-2 text-sm font-medium text-blue-700 transition-colors hover:bg-blue-50"
                    >
                      <span className="text-base leading-none">+</span>
                      <span className="sr-only">Anadir nuevo turno</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h2 className="text-3xl font-bold" style={{ color: '#1a365d' }}>
            Tareas y Registros
          </h2>
          <p className="text-gray-600">Selecciona las tareas por categorias:</p>
        </div>

        <div className="flex items-center gap-2">
          {hasSectionComment && (
            <span className="text-xs font-semibold text-blue-700">Comentario guardado</span>
          )}
          <button
            type="button"
            onClick={() => setIsHideCategoriasModalOpen(true)}
            className="relative inline-flex items-center justify-center w-10 h-10 rounded-full border border-red-200 text-red-700 bg-white hover:bg-red-50 transition-colors font-semibold"
            title="Ocultar categoria de tareas"
          >
            <span className="sr-only">Ocultar categoria de tareas</span>
            <span className="text-lg leading-none font-bold">-</span>
          </button>
          <button
            type="button"
            onClick={() => setIsAddCategoriaModalOpen(true)}
            className="relative inline-flex items-center justify-center w-10 h-10 rounded-full border border-green-200 text-green-700 bg-white hover:bg-green-50 transition-colors"
            title="Anadir categoria de tareas"
          >
            <span className="sr-only">Anadir categoria de tareas</span>
            <span className="text-xl leading-none font-bold">+</span>
          </button>
          <CommentButton
            onClick={() => onCommentClick({ key: 'section:tareas-registros', label: 'Tareas y Registros' })}
            hasComment={hasSectionComment}
            srLabel="Anadir comentario para Tareas y Registros"
            variant="circle"
            className="border-blue-200 text-blue-700 bg-white hover:bg-blue-50"
          />
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-3">
        {Array.isArray(horariosDisponibles) && horariosDisponibles.length > 0 && (
          <TurnoFilter
            isOpen={turnoFilterOpen}
            search={turnoFilterSearch}
            selected={turnoFilterSelected}
            filteredOptions={filteredTurnoOptions}
            buttonText={turnoFilterButtonLabel}
            isActive={turnoFilterActive}
            dropdownRef={turnoFilterRef}
            onToggle={onTurnoFilterToggle}
            onSearchChange={onTurnoFilterSearchChange}
            onToggleSelection={onTurnoFilterSelectionToggle}
            onClear={onTurnoFilterClear}
          />
        )}
        {tareasErrors.length > 0 && (
          <span className="rounded-full bg-red-50 px-3 py-1 text-xs font-semibold text-red-700">
            {tareasErrors.length} errores en datos recibidos
          </span>
        )}
      </div>

      {tareasEntries.length === 0 && (
        <p className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-6 text-center text-sm text-gray-600">
          No hay tareas disponibles para esta instancia.
        </p>
      )}

      <div className="space-y-4">
        {tareasEntries.map(([categoria, lista]) => {
          const categoriaKey = `categoria-tarea:${categoria}`;
          const categoriaHasComment = getCategoriaComment?.(categoria);
          const isCollapsed = collapsedCategories?.[categoria] ?? true;
          const hiddenList = hiddenTareasPorCategoria?.[categoria] || [];
          const visibles = Array.isArray(lista)
            ? lista.filter((t) => {
                const tareaId = t.id || t.name || t.nombre;
                if (typeof tareaCumpleFiltroDeTurnos === 'function' && !tareaCumpleFiltroDeTurnos(tareaId)) {
                  return false;
                }
                return true;
              })
            : [];

          const selectedCount = visibles.filter((t) => selectedTareas.includes(t.id || t.name || t.nombre)).length;

          return (
            <div key={categoria} className="border rounded-lg overflow-hidden bg-white shadow-sm">
              <div className="flex items-center justify-between gap-3 p-3 bg-gray-100 rounded-t-lg">
                <button
                  type="button"
                  onClick={() => onToggleCollapse(categoria)}
                  className="flex flex-1 items-center justify-between text-left px-3 py-2 border border-blue-300 rounded-full text-blue-700 bg-blue-50 hover:bg-blue-100 transition-colors"
                >
                  <span className="font-semibold text-lg text-blue-700">{categoria}</span>
                  <span className="text-sm text-blue-700">
                    {isCollapsed ? 'v' : '^'}
                  </span>
                </button>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    onClick={() => openTareasModal(categoria, 'hide')}
                    className="inline-flex items-center justify-center w-8 h-8 rounded-full border border-red-200 text-red-700 bg-white hover:bg-red-50 transition-colors"
                    title={`Ocultar tareas de ${categoria}`}
                  >
                    <span className="sr-only">Ocultar tareas</span>
                    <span className="text-lg leading-none font-bold">-</span>
                  </button>
                  <button
                    type="button"
                    onClick={() => openTareasModal(categoria, 'add')}
                    className="inline-flex items-center justify-center w-8 h-8 rounded-full border border-green-200 text-green-700 bg-white hover:bg-green-50 transition-colors"
                    title={`Anadir tarea en ${categoria}`}
                  >
                    <span className="sr-only">Anadir tarea</span>
                    <span className="text-lg leading-none font-bold">+</span>
                  </button>
                  {categoriaHasComment && (
                    <span className="text-xs font-semibold text-blue-700">Comentario guardado</span>
                  )}
                  <CommentButton
                    onClick={() => onCommentClick({ key: categoriaKey, label: categoria })}
                    hasComment={categoriaHasComment}
                    srLabel={`${categoriaHasComment ? 'Editar' : 'Anadir'} comentario para ${categoria}`}
                    variant="circle"
                  />
                </div>
              </div>

              {!isCollapsed && (
                <div className="space-y-3 p-4">
                  <div className="text-sm text-gray-600">
                    {selectedCount}/{visibles.length} seleccionadas
                  </div>
                  {visibles.length === 0 ? (
                    <p className="text-sm text-gray-500">Sin tareas en esta categoria.</p>
                  ) : (
                    visibles.map(renderTareaRow)
                  )}
                  {hiddenList.length > 0 && (
                    <div className="p-3 border-t text-sm text-gray-600">
                      <strong>Tareas ocultas en el grupo:</strong> {hiddenList.join(', ')}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {isAddCategoriaModalOpen && renderModalShell(
        <div className="space-y-4">
          <div className="flex items-start justify-between">
            <div>
              <h3 className="text-xl font-semibold text-gray-900">Anadir categoria</h3>
              <p className="text-sm text-gray-600">Crea nuevas categorias y revisa las que has ocultado.</p>
            </div>
            <button
              type="button"
              className="text-gray-500 hover:text-gray-800"
              onClick={() => { setIsAddCategoriaModalOpen(false); setNewCategoriaName(''); }}
              aria-label="Cerrar modal de anadir categoria"
            >
              x
            </button>
          </div>

          <form onSubmit={handleCreateCategoria} className="space-y-3">
            <label className="block text-sm font-medium text-gray-700" htmlFor="nueva-categoria-input">
              Nombre de la categoria
            </label>
            <input
              id="nueva-categoria-input"
              type="text"
              value={newCategoriaName}
              onChange={(e) => setNewCategoriaName(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Ej. Limpieza"
            />
            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={() => { setIsAddCategoriaModalOpen(false); setNewCategoriaName(''); }}
                className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 disabled:opacity-60"
                disabled={!newCategoriaName.trim()}
              >
                Anadir categoria
              </button>
            </div>
          </form>

          <div className="border-t pt-4">
            <h4 className="text-sm font-semibold text-gray-800 mb-2">Categorias ocultas</h4>
            {hiddenCategoriasList.length === 0 ? (
              <p className="text-sm text-gray-500">No hay categorias ocultas.</p>
            ) : (
              <ul className="space-y-2 max-h-48 overflow-y-auto pr-1">
                {hiddenCategoriasList.map((item) => (
                  <li key={item} className="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2">
                    <span className="text-sm text-gray-800">{item}</span>
                    {typeof onRestoreCategoria === 'function' && (
                      <button
                        type="button"
                        onClick={() => onRestoreCategoria(item)}
                        className="text-xs px-3 py-1 rounded-full border border-blue-200 text-blue-700 hover:bg-blue-50"
                      >
                        Restaurar
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}

      {isHideCategoriasModalOpen && renderModalShell(
        <div className="space-y-4">
          <div className="flex items-start justify-between">
            <div>
              <h3 className="text-xl font-semibold text-gray-900">Ocultar categorias</h3>
              <p className="text-sm text-gray-600">Selecciona las categorias que quieras ocultar temporalmente.</p>
            </div>
            <button
              type="button"
              className="text-gray-500 hover:text-gray-800"
              onClick={() => { setIsHideCategoriasModalOpen(false); setCategoriasToHide([]); }}
              aria-label="Cerrar modal de ocultar categorias"
            >
              x
            </button>
          </div>

          {tareasEntries.length === 0 ? (
            <p className="text-sm text-gray-500">No hay categorias disponibles para ocultar.</p>
          ) : (
            <div className="space-y-2 max-h-64 overflow-y-auto pr-1">
              {tareasEntries.map(([cat]) => (
                <label
                  key={cat}
                  className="flex items-center justify-between border border-gray-200 rounded-lg px-3 py-2 hover:border-blue-200"
                >
                  <div className="flex items-center gap-3">
                    <input
                      type="checkbox"
                      checked={categoriasToHide.includes(cat)}
                      onChange={() => toggleCategoriaToHide(cat)}
                      className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                    />
                    <span className="text-sm text-gray-800">{cat}</span>
                  </div>
                </label>
              ))}
            </div>
          )}

          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={() => { setIsHideCategoriasModalOpen(false); setCategoriasToHide([]); }}
              className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={handleConfirmHideCategorias}
              className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-60"
              disabled={categoriasToHide.length === 0}
            >
              Ocultar seleccionadas
            </button>
          </div>
        </div>
      )}

      {categoriaModalData && renderModalShell(
        <div className="space-y-4">
          <div className="flex items-start justify-between">
            <div>
              <h3 className="text-xl font-semibold text-gray-900">
                {categoriaModalData.mode === 'add' ? 'Anadir tarea' : 'Ocultar tareas'}
              </h3>
              <p className="text-sm text-gray-600">Categoria: {categoriaModalData.categoria}</p>
            </div>
            <button
              type="button"
              className="text-gray-500 hover:text-gray-800"
              onClick={() => { setCategoriaModalData(null); setNewTareaName(''); setTareasToHide([]); }}
              aria-label="Cerrar modal de tareas"
            >
              x
            </button>
          </div>

          {categoriaModalData.mode === 'add' && (
            <form onSubmit={handleCreateTarea} className="space-y-3">
              <label className="block text-sm font-medium text-gray-700" htmlFor="nueva-tarea-input">
                Nombre de la tarea
              </label>
              <input
                id="nueva-tarea-input"
                type="text"
                value={newTareaName}
                onChange={(e) => setNewTareaName(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Ej. Limpieza diaria"
              />
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  onClick={() => { setCategoriaModalData(null); setNewTareaName(''); }}
                  className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 disabled:opacity-60"
                  disabled={!newTareaName.trim()}
                >
                  Anadir tarea
                </button>
              </div>
            </form>
          )}

          {categoriaModalData.mode === 'hide' && (
            <>
              <div className="space-y-2 max-h-64 overflow-y-auto pr-1">
                {(tareasPorCategoriaDisponibles[categoriaModalData.categoria] || []).length === 0 ? (
                  <p className="text-sm text-gray-500">No hay tareas disponibles para ocultar.</p>
                ) : (
                  tareasPorCategoriaDisponibles[categoriaModalData.categoria].map((t) => {
                    const tareaId = t.id || t.name || t.nombre;
                    return (
                      <label
                        key={tareaId}
                        className="flex items-center justify-between border border-gray-200 rounded-lg px-3 py-2 hover:border-blue-200"
                      >
                        <div className="flex items-center gap-3">
                          <input
                            type="checkbox"
                            checked={tareasToHide.includes(t.name || t.nombre || tareaId)}
                            onChange={() => toggleTareaToHide(t.name || t.nombre || tareaId)}
                            className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                          />
                          <span className="text-sm text-gray-800">{t.name || t.nombre || 'Tarea'}</span>
                        </div>
                        {selectedTareas.includes(tareaId) && (
                          <span className="text-xs text-blue-600 font-medium">Seleccionada</span>
                        )}
                      </label>
                    );
                  })
                )}
              </div>

              <div className="border-t pt-3">
                <h4 className="text-sm font-semibold text-gray-800 mb-2">Tareas ocultas en esta categoria</h4>
                {hiddenTareasPorCategoria?.[categoriaModalData.categoria]?.length ? (
                  <ul className="space-y-2 max-h-32 overflow-y-auto pr-1">
                    {hiddenTareasPorCategoria[categoriaModalData.categoria].map((item) => (
                      <li key={item} className="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2">
                        <span className="text-sm text-gray-800">{item}</span>
                        {typeof onRestoreTarea === 'function' && (
                          <button
                            type="button"
                            onClick={() => onRestoreTarea(categoriaModalData.categoria, item)}
                            className="text-xs px-3 py-1 rounded-full border border-blue-200 text-blue-700 hover:bg-blue-50"
                          >
                            Restaurar
                          </button>
                        )}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-sm text-gray-500">No hay tareas ocultas en este grupo.</p>
                )}
              </div>

              <div className="flex justify-end gap-2 pt-2">
                <button
                  type="button"
                  onClick={() => { setCategoriaModalData(null); setTareasToHide([]); }}
                  className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={handleHideTareas}
                  className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-60"
                  disabled={tareasToHide.length === 0}
                >
                  Ocultar seleccionadas
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};
